module.exports = __webpack_public_path__ + "static/img/purchase_back.a8954f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/purchase_back.jpg?20181011
// module id = 44Zu
// module chunks = 1